import type { Meta, StoryFn } from '@storybook/react';
import type { CopyableTextProps } from './CopyableText';

import { CopyableText } from './CopyableText';

const codeString =
  '<CopyableText text={string} additionalClassName={string} ariaLabelCopy={string} ariaLabelHasBeenCopied={string} />';

// Adding custom styles for the story
const customStyle = document.createElement('style');
customStyle.type = 'text/css';
customStyle.innerHTML = '.customClass { font-weight: bold; color: #333; }';
document.head.appendChild(customStyle);

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/CopyableText',
  component: CopyableText,
  argTypes: {
    additionalClassName: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: CopyableText,
    codeString,
  },
} as Meta<CopyableTextProps>;

const Template: StoryFn<CopyableTextProps> = (args) => {
  return (
    <div style={{ padding: '1rem', backgroundColor: '#FFF', display: 'flex', gap: '1rem', alignItems: 'center' }}>
      <CopyableText {...args} />
      <span>EC</span>
      <span>Tutoring and Study Guidance Advanced Professional Programme in Conservation and Restoration</span>
    </div>
  );
};

export const CopyableTextExample = Template.bind({});
CopyableTextExample.args = {
  text: '3154CAR1VY',
  additionalClassName: 'customClass',
  ariaLabelCopy: 'Copy to clipboard',
  ariaLabelHasBeenCopied: 'Copied to clipboard',
};
